import React from 'react'
import { l } from '@manychat/manyui'

const EmailSuspensionDueToTOSNotification = () => {
  return <span>{l.translate('Email sendings was suspended due to TOS violations')}</span>
}

export default EmailSuspensionDueToTOSNotification
